import { render } from "./CoResidentsDetails.vue?vue&type=template&id=bdc6f46e"
import script from "./CoResidentsDetails.vue?vue&type=script&lang=js"
export * from "./CoResidentsDetails.vue?vue&type=script&lang=js"

import "./CoResidentsDetails.vue?vue&type=style&index=0&id=bdc6f46e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__